import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';

import { BingoConfigProviderService, BingoPlatformApiService, FeaturesClientConfig } from '@frontend/bingo/frontend-lib/core';
import { TrackingService } from '@frontend/vanilla/core';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';

import { BuyNowGridComponent } from '../components/session-bingo/buy-now-grid/buy-now-grid.component';
import { LoginService } from './login-Service';
import { ScreenNameService } from './screen-name.service';

@Injectable({
    providedIn: 'root',
})
export class SessionPackageService {
    finalGameDetails = new BehaviorSubject<any>(null);
    finalGameDetailsObsevable: Observable<any> = this.finalGameDetails.asObservable();
    multistakePrice = new BehaviorSubject<any>(null);
    multistakePriceObservable: Observable<any> = this.multistakePrice.asObservable();
    iosClassChanged = new BehaviorSubject<any>(null);
    iosClassChangedObservable: Observable<any> = this.iosClassChanged.asObservable();
    finalTopAndTailObj: any;
    totalPrice: number;
    scheduleIds: string;
    purchasedPackageId = new BehaviorSubject<any>(null);
    purchasedPackageIdObsevable: Observable<any> = this.purchasedPackageId.asObservable();
    isPurchase = new BehaviorSubject<any>(null);
    isPurchaseObsevable: Observable<any> = this.isPurchase.asObservable();
    data: any;
    iosClass: boolean;
    isInGameClient: boolean = false;
    featuresConfig: FeaturesClientConfig;
    packageInfo: any = {};
    packageIdOrderedList: string[] = [];
    bingoGameMappings: any;

    constructor(
        private api: BingoPlatformApiService,
        private screenNameService: ScreenNameService,
        private configProviderService: BingoConfigProviderService,
        private activeroute: ActivatedRoute,
        public loginService: LoginService,
        private dialog: MatDialog,
        private tracking: TrackingService,
    ) {
        if (this.activeroute.snapshot.queryParamMap.get('ingame=true')) {
            this.isInGameClient = true;
        }
    }

    updateTicketsSelectedDetails(obj: any) {
        if (obj && obj.totalPrice) {
            this.totalPrice = obj.totalPrice;
        } else {
            obj.totalPrice = this.totalPrice;
        }
        this.finalTopAndTailObj = obj;
        this.finalGameDetails.next(obj);
    }
    purshaseValidation(data: any) {
        if (data) {
            const maxValuePackageDiscount = data.package_discount_info[data.package_discount_info.length - 1]?.number_of_tickets;
            const noOfTicketsBought = data.purchase_status?.total_purchased_tickets;
            if (maxValuePackageDiscount && noOfTicketsBought) {
                for (let i = 0; i < data.package_discount_info.length; i++) {
                    if (data.package_discount_info[i].number_of_tickets <= maxValuePackageDiscount - noOfTicketsBought) {
                        return true;
                    }
                }
            }
        }
        return false;
    }

    updateMultiStakePrice(price: any) {
        this.multistakePrice.next(price);
    }

    getFinalGameObj() {
        return this.finalTopAndTailObj;
    }
    setClassStatusforIOS(value: any) {
        this.iosClass = value;
        this.iosClassChanged.next(this.iosClass);
    }

    getSessionList(package_type: string, gameData: any): Observable<any> {
        this.featuresConfig = this.configProviderService.provideFeaturesConfig();
        const startTime = new Date().getTime() / 1000;
        // let endTime = startTime + 604800;
        const endTime = startTime + 86400 * this.featuresConfig.sessionDays;
        const schIds: string[] = [];
        gameData.result.games_list.forEach((item: any) => {
            schIds.push(item.id);
        });
        this.scheduleIds = schIds.toString();
        //this.scheduleIds = ['186','251','521','364'].toString();
        return this.api.get(
            'SessionList?packageType=' + package_type + '&rooms=' + this.scheduleIds + '&startTime=' + startTime + '&endTime=' + endTime,
        );
    }

    getPackageDetails(package_type: string, packageId: string): Observable<any> {
        return this.api.get('GetPackageDetails?packageType=' + package_type + '&packageId=' + packageId);
    }

    getConfirmationDetails(purchageDetails: any) {
        return this.api.post('PurchasePackage', purchageDetails);
    }

    getSitecoreContent(PackageType: any): Observable<any> {
        return this.api.get('GetSessionOrPackageContent?packageType=' + PackageType);
    }
    getSessionGlobalMessages(): Observable<any> {
        return this.api.get('SessionGlobalMassages');
    }
    setPackageId(Id: any) {
        this.purchasedPackageId.next(Id);
    }
    onPackageInfoFromPackagesData(id: string, data: any) {
        if (data) {
            this.packageInfo[id] = this.packageInfo[id] || {};
            if (
                data?.result?.package_list?.packages_info[id]?.status == 'error' &&
                (data?.result?.package_list?.packages_info[id]?.message == 'Games Completed or in progress' ||
                    data?.result?.package_list?.packages_info[id]?.message == 'Package Id is not valid')
            ) {
                this.packageInfo[id].packagePurchased = true;
            }
            if (!this.packageInfo[id].packagePurchased) {
                this.packageInfo[id].packagePurchased = false;
            }
            this.formatGameDetails(id, data?.result?.package_list?.packages_info[id]);
            this.setGameDetails(id);
        }
    }

    formatGameDetails(id: string, gameInfo: any) {
        this.packageInfo[id].game_details = [];
        const _rooms = gameInfo.package_game_details
            ?.map((item: any) => item.room_id)
            .filter((value: any, index: any, self: any) => self.indexOf(value) === index);
        _rooms?.forEach((room: any) => {
            const package_details: any = {
                game_Info: [],
                package_bingoType: 0,
                package_bingoTypeImage: '',
                package_roomName: '',
                isFriendsRoom: false,
                isFabGrabRoom: false,
                isMultistake: false,
            };
            gameInfo.package_game_details?.forEach((info: any) => {
                if (room == info.room_id) {
                    package_details.game_Info.push(info);
                    package_details.package_bingoType = info.bingo_type;
                    //package_details.package_roomName = info.room_name;
                    package_details.package_roomName = this.getGameNameFromMappings(Number(info.room_id), info.room_name);
                }
            });
            if (package_details && package_details.game_Info.length > 0) {
                this.packageInfo[id].game_details.push(package_details);
            }
        });
    }

    setGameDetails(id: string) {
        this.packageInfo[id].game_details?.forEach((room: any) => {
            room.game_Info?.forEach((element: any) => {
                const startTime = new Date(element.start_time * 1000);
                const paddedHour = String(startTime.getHours()).padStart(2, '0');
                const paddedMinutes = String(startTime.getMinutes()).padStart(2, '0');
                let time = paddedHour + ':' + paddedMinutes;
                const month = String(startTime.getMonth() + 1).padStart(2, '0');
                time = startTime.getDate() + '/' + month + '-' + paddedHour + ':' + paddedMinutes;
                element.formatedStartTime = time;
                element.prize = (element.winning_amount?.Bonus || 0) + (element.winning_amount?.Cash || 0);
                element.tickets = this.packageInfo[id].selectedTickets;
            });
        });
    }

    getGameNameFromMappings(id: number, name: string): string {
        return this.bingoGameMappings[id] == null || this.bingoGameMappings[id] == undefined ? name : this.bingoGameMappings[id];
    }

    onPackageInfoFromSessionList(id: string, data: any) {
        if (data.purchase_status && data.purchase_status.no_of_tickets > 0) {
            data.staus_of_package = 'purchased';
        }

        data.selectedDiscount = 0;
        data.id = id;
        if (data.purchase_status?.no_of_tickets) {
            if (this.purshaseValidation(data)) {
                data.staus_of_package = 'purchase';
            } else {
                data.staus_of_package = 'purchased';
                data.packagePurchased = true;
            }
        }
        if (data.staus_of_package == 'purchased') {
            data.isPurchased = true;
        }
        let packageDiscountdetails = data.package_discount_info;
        if (packageDiscountdetails) {
            packageDiscountdetails.sort((a: any, b: any) => a.number_of_tickets - b.number_of_tickets);
            data.package_discount_info = packageDiscountdetails;
        }
        let unsortedDetails = data?.package_game_details;
        if (unsortedDetails) {
            unsortedDetails.sort((a: any, b: any) => (a.start_time > b.start_time ? 1 : -1));
            data.package_game_details = unsortedDetails;
        }
        this.packageInfo[id] = { ...this.packageInfo[id], ...data };
        this.assignPriceFrom(id);
        this.assignUniqueBingoType(id);
    }

    assignPriceFrom(id: string) {
        const discount = Number(this.packageInfo[id].package_discount_info[0].discount);
        const no_of_tickets = Number(this.packageInfo[id].package_discount_info[0].number_of_tickets);
        let priceFrom: number = 0;
        for (let i = 0; i < this.packageInfo[id].package_game_details.length; i++) {
            priceFrom += this.packageInfo[id].package_game_details[i].card_cost * no_of_tickets;
        }
        priceFrom = priceFrom - priceFrom * discount;
        this.packageInfo[id].calculatedPriceFrom = priceFrom;
    }

    assignUniqueBingoType(id: string) {
        const packageGame: any[] = this.packageInfo[id].package_game_details;
        const gameRoomArray: any[] = [];
        let uniqueGameRoom: any[] = [];
        let uniqueFeature: any[] = [];
        let winningAmountCash: number = 0;
        packageGame.forEach((val: any) => {
            gameRoomArray.push(val.bingo_type);
            const features = val.features;
            const winningAmount = val.winning_amount;
            features.forEach((feature: string) => {
                if (!uniqueFeature.includes(feature)) uniqueFeature.push(feature);
            });
            if (winningAmount) {
                winningAmountCash += winningAmount.Cash || winningAmount.Cash_GBP || 0;
                winningAmountCash += winningAmount.Bonus || winningAmount.Bonus_GBP || 0;
            }
            uniqueGameRoom = gameRoomArray.filter((v, i, a) => a.indexOf(v) === i);
        });
        this.packageInfo[id].uniqueBingoType = uniqueGameRoom;
        this.packageInfo[id].uniqueGameFeature = uniqueFeature;
        this.packageInfo[id].totalPrize = winningAmountCash;
        this.packageInfo[id].totalPrize = Math.round((this.packageInfo[id].totalPrize + Number.EPSILON) * 100) / 100;
    }

    getPackageInfo(id: string) {
        return this.packageInfo[id];
    }

    clearPackageInfo() {
        this.packageInfo = {};
        this.packageIdOrderedList = [];
    }

    unhideAllPackages() {
        for (let item in this.packageInfo) {
            this.packageInfo[item].hideItem = false;
        }
    }

    filterPackages(filterItem: any) {
        for (let pkgItem in this.packageInfo) {
            let type = filterItem.type;
            this.packageInfo[pkgItem].hideItem = true;
            this.packageInfo[pkgItem].package_game_details.forEach((item: any) => {
                if (filterItem.value) {
                    if (item[type] == filterItem.value) {
                        this.packageInfo[pkgItem].hideItem = false;
                    }
                }
                if (type == 'features' && item.features && item.features.length > 0) {
                    this.packageInfo[pkgItem].hideItem = false;
                }
            });
        }
    }

    setIsPurchase(Id: any, isPurchase: any) {
        this.isPurchase.next({ Id: Id, isPurchase: isPurchase });
    }
    packageTracking(CategoryEvent: any, packageOrSession: any, packageids: any, LocationEvent: any, EventDetails: any) {
        this.tracking.triggerEvent('Event.Tracking', {
            'component.CategoryEvent': CategoryEvent,
            'component.LabelEvent': packageOrSession,
            'component.ActionEvent': ' click',
            'component.PositionEvent': packageids,
            'component.LocationEvent': LocationEvent,
            'component.EventDetails': EventDetails,
            'component.URLClicked': 'not applicable',
        });
    }
    iconClick(gamename: any, action: any, infomode: any, package_type: any) {
        this.tracking.updateDataLayer({
            'component.CategoryEvent': 'Bingo',
            'component.LabelEvent': package_type,
            'component.ActionEvent': action,
            'component.PositionEvent': 'not applicable',
            'component.LocationEvent': gamename,
            'component.EventDetails': infomode,
            'component.URLClicked': 'not applicable',
        });
    }
    buySessionAandPackage(package_type: any, action: any, gamename: any, EventDetails: any) {
        this.tracking.updateDataLayer({
            'component.CategoryEvent': 'Bingo',
            'component.LabelEvent': package_type,
            'component.ActionEvent': action,
            'component.PositionEvent': 'confirm purchase overlay',
            'component.LocationEvent': gamename,
            'component.EventDetails': EventDetails,
            'component.URLClicked': 'not applicable',
        });
    }

    openBuyNowGrid(data: any) {
        this.loginService.clearnBingoforcedUrl();
        const DialogRef = this.dialog.open(BuyNowGridComponent, {
            panelClass: 'session-bingo-popup',
            data: data,
        });
        const afteropenessubcription: Subscription = DialogRef.afterOpened().subscribe(() => {
            if (afteropenessubcription) {
                const htmltag = document.getElementsByTagName('html');
                if (htmltag && htmltag[0]) {
                    if (!htmltag[0].classList.contains('cdk-global-scrollblock')) {
                        htmltag[0].classList.add('cdk-global-scrollblock');
                    }
                }

                afteropenessubcription.unsubscribe();
            }
        });
        const afterclosesubcription: Subscription = DialogRef.afterClosed().subscribe(() => {
            if (afterclosesubcription) {
                const htmltag = document.getElementsByTagName('html');
                if (htmltag && htmltag[0]) {
                    if (htmltag[0].classList.contains('cdk-global-scrollblock')) {
                        htmltag[0].classList.remove('cdk-global-scrollblock');
                    }
                }
                afterclosesubcription.unsubscribe();
            }
        });
    }

    loadPopupsBasedOnCondition(popUpData: any) {
        if (this.isInGameClient) {
            this.openBuyNowGrid(popUpData.data);
        } else {
            this.screenNameService.validateScreenNameChat().then((response) => {
                if (response) {
                    this.openBuyNowGrid(popUpData.data);
                } else {
                    this.screenNameService.openScreenChatNameComponent(popUpData);
                }
            });
        }
    }

    cancelSessionAandPackage(package_type: any, action: any, gamename: any, EventDetails: any) {
        if (localStorage.getItem('confirm') !== 'true') {
            this.tracking.updateDataLayer({
                'component.CategoryEvent': 'Bingo',
                'component.LabelEvent': package_type,
                'component.ActionEvent': action,
                'component.PositionEvent': 'confirm purchase overlay',
                'component.LocationEvent': gamename,
                'component.EventDetails': EventDetails,
                'component.URLClicked': 'not applicable',
            });
            localStorage.removeItem('confirm');
        }
    }

    sortPackages(filteredItems: any) {
        let preparedFilterItems = filteredItems.sort((a: any, b: any) => a?.package_name.localeCompare(b?.package_name));
        preparedFilterItems = preparedFilterItems.sort((a: any, b: any) => {
            if (a.sort_weight_value < b.sort_weight_value) {
                return -1;
            }
            if (a.sort_weight_value > b.sort_weight_value) {
                return 1;
            }
            return 0;
        });
        return preparedFilterItems;
    }
}
